import { Grid } from '@mui/material';
import { FunctionComponent, useCallback, useEffect, useState } from 'react';
import { IConfirmationDialogWithInputProps } from './types';
import { FormInput } from '../../../CoreLib/library';
import { ConfirmDialog } from '..';

export const ConfirmationDialogWithInput: FunctionComponent<IConfirmationDialogWithInputProps> = (props) => {
    const { open,
        onClose,
        title,
        titleIcon,
        cancelText,
        confirmText,
        initValue,
        formLabel,
        save,
        multiline,
        requireConfirmation
    } = props;

    const [formText, setFormText] = useState<string>(initValue ?? '');
    const [errorText, setErrorText] = useState('');

    const beforeClose = useCallback(() => {
        setFormText('');
        setErrorText('');
        onClose();
    }, [onClose]);

    useEffect(() => {
        if (initValue) {
            setFormText(initValue);
        }
    }, [initValue]);

    const onSave = () => {
        if (formText !== '') {
            save(formText);
            beforeClose();
        } else {
            setErrorText('This field is required');
        }
    };

    return (
        <ConfirmDialog
            open={open}
            onClose={beforeClose}
            content={
                <Grid container direction='column' marginTop={2}>
                    <FormInput
                        value={formText}
                        onChange={(e) => {
                            setFormText(e.target.value);
                        }}
                        label={formLabel}
                        errorText={errorText}
                        fullWidth
                        required
                        rows={multiline ? 3 : undefined}
                    />
                </Grid>
            }
            title={title}
            titleIcon={titleIcon}
            cancelText={cancelText}
            confirmText={confirmText}
            onConfirm={onSave}
            requireConfirmation={requireConfirmation}
        />
    );
};
